module.exports = __webpack_public_path__ + "static/media/e62155a8-ef1b-482e-bdad-818f5458024f.7572e0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/e62155a8-ef1b-482e-bdad-818f5458024f.png
// module id = 1475
// module chunks = 0